import { Helmet } from "react-helmet-async";

function SEO({
  title = "Plot Division",
  description = "Plan stories, build worlds, write books, and grow your creative universe.",
  image = "https://plotdivision.com/preview.png",
  url = "https://plotdivision.com/",
  type = "website",
  robots = "index, follow, max-image-preview:large",
  schema = null,
}) {
  const schemaJson = schema ? JSON.stringify(schema) : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content="Plot Division" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />

      {schemaJson ? (
        <script type="application/ld+json">{schemaJson}</script>
      ) : null}
    </Helmet>
  );
}

export default SEO;